/** Эвристика для отчётов (не идентификатор устройства). */
export function computePlatformHint(): "ios" | "android" | "desktop" | "unknown" {
  try {
    const nav = window.navigator as Navigator & { standalone?: boolean };
    if (nav.standalone === true) return "ios";
    const ua = navigator.userAgent || "";
    if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
    if (/android/i.test(ua)) return "android";
    const mobile = /Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    if (mobile) return "android";
    if (/Win32|Win64|Macintosh|X11|Linux x86_64/i.test(ua)) return "desktop";
    return "unknown";
  } catch {
    return "unknown";
  }
}
